import { FilestackImageData } from 'api/types/shared.types';
import algoliaSearch from 'utils/algoliaSearch';
import { requiredConfig } from 'utils/config';
import { del, getJson, postJson } from 'utils/http';
import getSearchConfig from 'utils/search/getSearchConfig';

type PublicUserData = {
  id: string;
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  description: string | null | undefined;
  descriptionTruncated: string | null | undefined;
  links: Array<string>;
  image: FilestackImageData | null | undefined;
};
export type Pin = {
  date: string | null | undefined;
  id: string;
  created: string;
  updated: string;
  userId: string;
  latitude: number;
  longitude: number;
  withProfile: boolean;
  text: string;
  profile?: PublicUserData;
};
export type PinInfo = {
  latitude: number;
  longitude: number;
  withProfile: boolean;
  text: string;
};
// Redux
export type DaysMap = {
  mapState: boolean | null | undefined;
};
export type Pins = Array<Pin>;
export function setPin(date: string, pinInfo: PinInfo): Promise<Pin> {
  return postJson(`/data/website/idealist-days-map/${date}`, pinInfo).then(
    ({ pin }) => pin
  );
}
export function deletePin(pinId: string): Promise<void> {
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'Promise<unknown>' is not assignable to type ... Remove this comment to see the full error message
  return del(`/data/website/idealist-days-map-pins/${pinId}`);
}
export function fetchPin(pinId: string): Promise<Pin> {
  return getJson(`/data/website/idealist-days-map-pins/${pinId}`).then(
    ({ pin }) => pin
  );
}
export function fetchPins(date: string): Promise<Array<Pin>> {
  return getJson(`/data/website/idealist-days-map/${date}`).then(
    ({ pins }) => pins
  );
}
export function fetchIdealistDaysEvents(
  date: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<Array<Record<string, any>>> {
  const searchConfig = getSearchConfig();
  return algoliaSearch(searchConfig, '', {
    index: requiredConfig('algolia', 'siteIndexName'),
    attributesToRetrieve: '*',
    // TODO fetch only what's needed
    hitsPerPage: 1000,
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ index: string; attributesToRet... Remove this comment to see the full error message
    facetFilters: [[`idealistDay:${date}`], ['type:IDEALIST_DAY_EVENT']],
  }).then(({ hits }) => hits);
}
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function fetchGroups(): Promise<Array<Record<string, any>>> {
  const searchConfig = getSearchConfig();
  return algoliaSearch(searchConfig, '', {
    index: requiredConfig('algolia', 'siteIndexName'),
    attributesToRetrieve: '*',
    // TODO fetch only what's needed
    hitsPerPage: 1000,
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ index: string; attributesToRet... Remove this comment to see the full error message
    facetFilters: [['type:GROUP']],
  }).then(({ hits }) => hits);
}
